import React from "react";
import type { MapCanvasValue } from "../../contexts/MapCanvasContext/MapCanvasContext.types";

/** Preview only; saved highlights are rendered by the native availability layer. */
export function ImportRoomHighlightOverlay({ map }: { map: MapCanvasValue }) {
  return React.createElement(
    "g",
    { "aria-label": "Meeting room highlight preview", pointerEvents: "none" },
    map.shapes.flatMap((s) =>
      s.type === "spot" &&
      s.spotType === "meeting_room" &&
      s.stateArea?.kind === "polygon"
        ? [
            <polygon
              key={s.id}
              points={s.stateArea.points?.map((p) => `${p.x},${p.y}`).join(" ")}
              transform={`translate(${s.x},${s.y}) rotate(${s.rotation || 0}) scale(${s.scaleX ?? 1},${s.scaleY ?? 1})`}
              fill="#3b82f6"
              fillOpacity={0.12}
              stroke="#2563eb"
              strokeWidth={1.5}
              vectorEffect="non-scaling-stroke"
            />
          ]
        : []
    )
  );
}
